import React, {Component} from 'react';
import {Grid, Row, Col, Tabs, Tab} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import PokazRozkladContainer from "./pokazRozklad/PokazRozkladContainer";
import GenerujRozkladContainer from "./generujRozklad/GenerujRozkladContainer";
import GenerujRozkladContainerOld from "./generujRozkladPojedynczo/GenerujRozkladPojedynczoContainer";

export default class RozkladContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
        };
        this.changeActiveTab = this.changeActiveTab.bind(this)
    }

    renderContent(){
        if(this.state.activeTab === 1){
            return <PokazRozkladContainer/>
        }
        else if(this.state.activeTab ===3){
         return <GenerujRozkladContainer/>
        }
        else{
            return <GenerujRozkladContainerOld/>
        }
    }

    changeActiveTab(eventKey){
        this.setState({activeTab:eventKey})
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'RozkladContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {addressUrl: '/konfiguracja/rozklad-jazdy', text: 'Rozkład jazdy'},{addressUrl: '/konfiguracja/rozklad-jazdy/rozklad', text: 'Rozkład'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz} history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <Tabs defaultActiveKey={1} id="rozklad-tab" onSelect={this.changeActiveTab}>
                                <Tab eventKey={1} title="Pokaż rozkład" >
                                </Tab>
                                {/*<Tab eventKey={2} title="Pokaż rozkład OLD">
                                </Tab>*/}
                                <Tab eventKey={3} title="Generuj rozkład">
                                </Tab>
                                <Tab eventKey={4} title="Generuj dla danej trasy">
                                </Tab>
                            </Tabs>
                        </Col>
                        <Col sm={12}>
                            <div style={{marginTop:'15px'}}>
                                {this.renderContent()}
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/rozklad/RozkladContainer.js